import React from 'react'

export const TopSecondIcon = () => {
    return (
        // <div className="layerTopRightIconWrapper">
        //     <div className="layerIconWrapperInsider">
        //         <div className="layerIconInsider2">
        //             <div className="layerIconSvg">
        //                 <span className="material-icons" style={{ marginLeft: '3px', marginTop: '4px',fontSize:'20px' }}>play_arrow</span>
        //             </div>
        //         </div>
        //     </div>
        // </div>
        <></>
    )
}
export default TopSecondIcon;